export default "__VITE_ASSET__C2hFJLdc__"